export default {
  async getList () {
  }
}
